module.exports = __webpack_public_path__ + "img/2.3d192b88.jpg";